import type { MessageSchema } from '@/locales/locales.model'

export default function useL10n() {
  const { t, te, locale } = useI18n<{ message: MessageSchema }>()

  return { t, te, locale }
}
